import { Box, Theme, Typography, styled, useMediaQuery } from "@mui/material";
import {
  BottomActionArea,
  BottomActionButton,
  FormBody,
  FormContentContainer,
  FormHeader,
} from "../../components";
import { NavigateBeforeButton } from "@components";
import { useNavigate } from "react-router-dom";

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const DescriptionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  padding: "24px 8px",
  gap: "32px",
});

const StepsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  gap: "8px",
  backgroundColor: theme.palette.background.paper,
}));

const StepContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  height: "70px",
  padding: "0px 16px",
  gap: "26px",
});

const StepContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "90%",
  gap: "16px",
  fontSize: "14px",
});

const StepNumber = styled(Box)(({ theme }) => ({
  minWidth: "24px",
  minHeight: "24px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.primary.extralight,
  color: theme.palette.text.primary,
  fontWeight: 600,
}));

const IconContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: "10%",
  minWidth: "10%",
});

const StepIcon = styled("img")({
  width: "45px",
  height: "45px",
  alignSelf: "center",
});

const ImportantInfo = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.secondary,
}));

const Bold = styled("span")({
  fontWeight: 600,
});

export function IdentityVerification() {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  return (
    <>
      <FormHeader
        useMekiDocIcon={isDesktop}
        title={!isDesktop ? "Verificación de identidad" : undefined}
        titleColor="white"
        left={
          <NavigateBeforeButton
            iconColor="white"
            onClick={() => navigate(-1)}
          />
        }
      />
      <FormContentContainer disableGutters>
        <FormBody>
          <Title variant="h5" fontWeight={"medium"}>
            Verificación de identidad
          </Title>
          <DescriptionContainer>
            <Typography>
              Tendrás que hacerlo <Bold>UNA SOLA VEZ</Bold> para crear tu Firma
              Electrónica Avanzada.
            </Typography>

            <StepsWrapper>
              <StepContainer>
                <StepContent>
                  <StepNumber>1</StepNumber>
                  Inicia sesión con Clave única
                </StepContent>
                <IconContainer>
                  <StepIcon src="/assets/images/esign-clave-unica-icon.svg" />
                </IconContainer>
              </StepContainer>

              <StepContainer>
                <StepContent>
                  <StepNumber>2</StepNumber>
                  Completa el Nº de serie de tu cédula de identidad
                </StepContent>
                <IconContainer>
                  <StepIcon src="/assets/images/esign-ci-icon.svg" />
                </IconContainer>
              </StepContainer>

              <StepContainer>
                <StepContent>
                  <StepNumber>3</StepNumber>
                  Responde preguntas del Registro Civil
                </StepContent>
                <IconContainer>
                  <StepIcon src="/assets/images/esign-questions-icon.svg" />
                </IconContainer>
              </StepContainer>
            </StepsWrapper>

            <ImportantInfo>
              La información entregada no será almacenada ni empleada para fines
              distintos a verificar tu identidad.
            </ImportantInfo>
          </DescriptionContainer>

          <BottomActionArea>
            <BottomActionButton
              onClick={() =>
                navigate(
                  "/app/registro/firma-electronica-avanzada/validation-challenge",
                )
              }
            >
              Verificar identidad
            </BottomActionButton>
          </BottomActionArea>
        </FormBody>
      </FormContentContainer>
    </>
  );
}
